<tec-modal
	[isVisible]="true"
	[title]="'PROCESSES.DETAIL.IDENTITY' | translate"
	(closeEvent)="closeModal()"
>
	<ng-container body>
		@if (identity) {
			<div class="grid grid-i2">
				<tec-info-group [label]="'PROCESSES.DETAIL.NAME' | translate">
					<span>{{ fullName || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
				</tec-info-group>
				<tec-info-group [label]="'PROCESSES.DETAIL.NUM_DOCUMENT' | translate">
					<span>{{ identity?.identifier || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
				</tec-info-group>
				<tec-info-group [label]="'PROCESSES.DETAIL.TYPE_DOCUMENT' | translate">
					<span>{{
						masterService.hasTranslation('MASTER.DOCUMENT_TYPE.' + identity?.document_type)
							? ('MASTER.DOCUMENT_TYPE.' + identity?.document_type | translate)
							: (identity?.document_type ?? ('GENERAL.NOT_AVAILABLE' | translate))
					}}</span>
				</tec-info-group>
				<tec-info-group [label]="'PROCESSES.DETAIL.EXPIRY_DATE' | translate">
					@if (identity?.expiration_date) {
						<tec-icon name="icon-calendar"></tec-icon>
					}
					<span>{{ (identity?.expiration_date | expirationDate: 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
				</tec-info-group>
				<tec-info-group [label]="'PROCESSES.DETAIL.BIRTH_DATE' | translate">
					@if (identity?.birthdate) {
						<tec-icon name="icon-calendar"></tec-icon>
					}
					<span>{{ (identity?.birthdate | safeDate: 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
					@if (yearsOld != null) {
						<tec-tag status="success">
							{{ 'PROCESSES.DETAIL.YEARS' | translate: { years_old: yearsOld } }}
						</tec-tag>
					}
				</tec-info-group>
				<tec-info-group [label]="'PROCESSES.DETAIL.GENDER' | translate">
					<span>{{
						masterService.hasTranslation('MASTER.GENDERS.' + identity?.gender)
							? ('MASTER.GENDERS.' + identity?.gender | translate)
							: ('GENERAL.NOT_AVAILABLE' | translate)
					}}</span>
				</tec-info-group>
				<tec-info-group [label]="'PROCESSES.DETAIL.NACIONALITY' | translate">
					<span>{{
						masterService.hasTranslation('MASTER.COUNTRIES.' + identity?.nationality)
							? ('MASTER.COUNTRIES.' + identity?.nationality | translate)
							: nationalityFallback && masterService.hasTranslation('MASTER.COUNTRIES.' + nationalityFallback)
								? ('MASTER.COUNTRIES.' + nationalityFallback | translate)
								: (nationalityFallback ?? ('GENERAL.NO_INFO' | translate))
					}}</span>
				</tec-info-group>
			</div>
		} @else {
			<tec-empty-state
				[title]="'GENERAL.NO_DATA' | translate"
				[size]="'default'"
				[type]="'empty'"
			></tec-empty-state>
		}
	</ng-container>
</tec-modal>
